export enum ListingSlugType {
  ForSale = 'for-sale',
  Sold = 'sold-in',
}

export enum ListingStatusRoute {
  Liked = 'liked',
  Inquired = 'inquired',
}

export enum ListStatusType {
  ForSale = 'for-sale',
  Sold = 'sold',
  Liked = 'liked',
  Inquired = 'inquired',
}
